import { render } from "./YellowEditConsultantModal.vue?vue&type=template&id=6b53b4ea"
import script from "./YellowEditConsultantModal.vue?vue&type=script&lang=js"
export * from "./YellowEditConsultantModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__